<template>
  <section class="container">
    <div class="sub_contents_wrap">
      <div class="wrap_con type_bt_wrap">
        <div class="left_con">
          <div class="fillter_left_box">
            <h4>
              <span>{{ $t("product.filter") }}</span>
              <a href="#" @click="filterInit()" class="btn-primary btn-sm">{{
                $t("product.init")
              }}</a>
              <a href="#" class="l_fillter_bt" @click="changeShowFilter()"
                ><em>{{ $t("product.filter") }}</em></a
              >
            </h4>
            <div class="fillter_inner">
              <div
                class="fillter_group_box"
                v-bind:class="{ f_g_active: filterShow.product }"
              >
                <p>
                  <a href="#" @click="changeShowProductFilter()">{{
                    $t("product.product")
                  }}</a>
                </p>
                <ul v-if="productList" v-show="filterShow.product">
                  <li v-for="(item, index) in productList" :key="index">
                    <label class="facet_chk_text"
                      ><input
                        type="checkbox"
                        class="facet_chk"
                        name="prodId"
                        :value="item.prodId"
                        v-model="form.paramProductList"
                        @change="onChangeChild(item.prodId), changeFilter()"
                      />{{ item.prodName }}</label
                    >
                    <ul
                      v-if="item.children"
                      class="f_g_child"
                      v-bind:class="{ f_g_active: filterShow.product2 }"
                    >
                      <p>
                        <a href="#" @click="changeShowProduct2Filter()">Product</a>
                      </p>
                      <li
                        v-for="(citem, cindex) in item.children"
                        :key="cindex"
                        v-show="filterShow.product2"
                      >
                        <label class="facet_chk_text"
                          ><input
                            type="checkbox"
                            class="facet_chk"
                            name="prodId"
                            :value="citem.prodId"
                            v-model="form.paramProductList"
                            @change="onChangeChild(citem.prodId), changeFilter()"
                          />{{ citem.prodName }}</label
                        >
                      </li>
                    </ul>
                  </li>
                </ul>
              </div>
              <div
                class="fillter_group_box"
                v-bind:class="{ f_g_active: filterShow.doctype }"
              >
                <p>
                  <a href="#" @click="changeShowDoctypeFilter()">{{
                    $t("product.documentType")
                  }}</a>
                </p>
                <ul v-if="doctypeList" v-show="filterShow.doctype">
                  <li v-for="(item, index) in doctypeList" :key="index">
                    <label class="facet_chk_text"
                      ><input
                        type="checkbox"
                        class="facet_chk"
                        name="doctypeId"
                        :value="item.doctypeId"
                        v-model="form.paramDoctypeList"
                        @change="changeFilter()"
                      />{{ item.doctypeName }}</label
                    >
                  </li>
                </ul>
              </div>
              <div
                class="fillter_group_box"
                v-bind:class="{ f_g_active: filterShow.exhaust }"
              >
                <p>
                  <a href="#" @click="changeShowExhaustFilter()">{{
                    $t("product.cerfication")
                  }}</a>
                </p>
                <ul v-if="ecList" v-show="filterShow.exhaust">
                  <li v-for="(item, index) in ecList" :key="index">
                    <label class="facet_chk_text"
                      ><input
                        type="checkbox"
                        class="facet_chk"
                        name="exhaustCertiId"
                        :value="item.exhaustCertiId"
                        v-model="form.paramExhaustCertiList"
                        @change="changeFilter()"
                      />{{ item.exhaustCertiName }}</label
                    >
                  </li>
                </ul>
              </div>
              <div
                class="fillter_group_box"
                v-bind:class="{ f_g_active: filterShow.lang }"
              >
                <p>
                  <a href="#" @click="changeShowLangFilter()">{{
                    $t("product.language")
                  }}</a>
                </p>
                <ul v-if="langList" v-show="filterShow.lang">
                  <li v-for="(item, index) in langList" :key="index">
                    <label class="facet_chk_text"
                      ><input
                        type="checkbox"
                        class="facet_chk"
                        name="codeId"
                        :value="item.codeId"
                        v-model="form.paramLangList"
                        @change="changeFilter()"
                      />{{ item.codeName }}</label
                    >
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div class="middle_con">
          <div class="con_list_top">
            <div class="c_l_left">
              <span class="result_t">
                {{ pagingVO.totalRecord }}
                {{ $t("product.results") }}</span
              >
            </div>
            <div class="c_l_r_bt">
              <div class="btn-group">
                <a
                  v-if="form.publishedYn == ''"
                  class="btn btn-outline-secondary btn-sm toggle_arr"
                  href="#"
                  role="button"
                  id="dropdownMenuLink"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  {{ $t("product.all") }}
                </a>
                <a
                  v-else-if="form.publishedYn == 'Y'"
                  class="btn btn-outline-secondary btn-sm toggle_arr"
                  href="#"
                  role="button"
                  id="dropdownMenuLink"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  {{ $t("product.distribute") }}
                </a>
                <a
                  v-else-if="form.publishedYn == 'N'"
                  class="btn btn-outline-secondary btn-sm toggle_arr"
                  href="#"
                  role="button"
                  id="dropdownMenuLink"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  {{ $t("product.unDistribute") }}
                </a>

                <ul class="dropdown-menu" aria-labelledby="dropdownMenuLink">
                  <li>
                    <a class="dropdown-item" href="#" @click="publishedYnChange('')">{{
                      $t("product.all")
                    }}</a>
                  </li>
                  <li>
                    <a class="dropdown-item" href="#" @click="publishedYnChange('Y')">{{
                      $t("product.distribute")
                    }}</a>
                  </li>
                  <li>
                    <a class="dropdown-item" href="#" @click="publishedYnChange('N')">{{
                      $t("product.unDistribute")
                    }}</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="f_w_box">
            <div class="product_list_wrap" v-if="docList.length != 0">
              <ul>
                <li v-for="(item, index) in docList" :key="index">
                  <p class="p_l_bt_box">
                    <a
                      v-if="item.authWebhelpYn == 'Y' && item.verNodeRef"
                      :href="
                        '/docview/model/lang/' +
                        item.verNodeRef.replace('workspace://SpacesStore/', '') +
                        '/index.html'
                      "
                      target="_blank"
                      class="p_l_icon01"
                      title="Web View"
                      >WebHelp</a
                    >
                    <!-- <a
                      v-else
                      class="p_l_icon01 disabled_type text_cursor"
                      title="Web View"
                      >WebHelp</a
                    > -->
                    <a
                      v-if="item.authViewYn == 'Y' && item.fileNodeRef"
                      :href="
                        '/document/preview?noCache=' +
                        date +
                        '&uid=' +
                        item.fileNodeRef.replace('workspace://SpacesStore/', '')
                      "
                      target="_blank"
                      class="p_l_icon04"
                      title="PDF View"
                      >View</a
                    >
                    <!-- <a
                      v-else
                      class="p_l_icon04 disabled_type text_cursor"
                      title="PDF View"
                      >View</a
                    > -->
                    <a
                      v-if="item.authDownloadYn == 'Y' && item.fileNodeRef"
                      @click="
                        pdfDownload(
                          item.fileNodeRef.replace('workspace://SpacesStore/', '')
                        )
                      "
                      class="p_l_icon02"
                      title="PDF Download"
                      >PDF</a
                    >
                    <!-- <a
                      v-else
                      class="p_l_icon02 disabled_type text_cursor"
                      title="PDF Download"
                      >PDF</a
                    > -->
                    <a
                      v-if="item.authYn == 'Y'"
                      href="javascript:void(0)"
                      @click="showHistoryPopup(item.docId, item.docTitle)"
                      class="p_l_icon03"
                      title="Version History"
                      >History</a
                    >
                    <!-- <a
                      v-else
                      class="p_l_icon03 disabled_type text_cursor"
                      title="Version History"
                      >History</a
                    > -->
                  </p>
                  <a href="#" class="p_l_title text_cursor">
                    <span v-if="item.modelName != null">[{{ item.modelName }}]</span>
                    {{ item.docTitle }}
                    <em v-if="item.partNo != null && item.partNo != ''">
                      | {{ item.modelcodeName }} | {{ item.exhaustCertiName }} |
                      {{ item.doctypeName }}
                      <span v-if="item.modelName != null">| {{ item.modelName }}</span> |
                      {{ item.langName }} | {{ item.partNo }} |
                      {{ item.publishedDate }}</em
                    >
                    <em v-else>
                      | {{ item.modelcodeName }} | {{ item.exhaustCertiName }} |
                      {{ item.doctypeName }}
                      <span v-if="item.modelName != null">| {{ item.modelName }}</span> |
                      {{ item.langName }} | {{ item.publishedDate }}</em
                    >
                  </a>
                </li>
              </ul>
            </div>
            <!-- 데이터 없을때 -->
            <div class="product_list_wrap" v-if="docList.length == 0">
              <div class="search_no_data">
                <span>Your search did not match any documents.</span>
              </div>
            </div>

            <!-------------------페이징----------------------------------------->
            <div v-if="docList.length != 0" class="paging_nav">
              <div class="paging_nav">
                <a
                  href="javascript:void(0);"
                  v-if="pagingVO.startPage <= pagingVO.blockSize"
                  class="page_select prev_page disabled"
                  >이전페이지 이동</a
                >
                <a
                  v-else
                  href="javascript:void(0);"
                  class="page_select prev_page"
                  @click="searchPage(pagingVO.startPage - pagingVO.blockSize)"
                  v-bind:data-page="pagingVO.startPage - pagingVO.blockSize"
                  >이전페이지 이동</a
                >
                <span
                  v-for="(pages, index) in pagingVO.endPage - pagingVO.startPage + 1"
                  :key="index"
                >
                  <strong v-if="pagingVO.startPage + index == pagingVO.currentPage">{{
                    pagingVO.startPage + index
                  }}</strong>
                  <a
                    href="javascript:void(0);"
                    v-else
                    @click="searchPage(pagingVO.startPage + index)"
                    >{{ pagingVO.startPage + index }}</a
                  >
                </span>
                <a
                  v-if="pagingVO.endPage >= pagingVO.totalPage"
                  href="javascript:void(0);"
                  class="page_select next_page disabled"
                  >다음페이지 이동</a
                >
                <a
                  v-else
                  href="javascript:void(0);"
                  @click="searchPage(pagingVO.endPage + 1)"
                  v-bind:data-page="pagingVO.endPage + 1"
                  class="page_select next_page"
                  >다음페이지 이동</a
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--history 모달-->
    <HistoryModal
      :docId="form.docId"
      :docTitle="docTitle"
      v-if="showModal"
      @close="showModal == false"
      ref="historyModal"
    >
      <template slot="footer">
        <button
          type="button"
          @click="closeModal"
          class="btn btn-secondary"
          data-bs-dismiss="modal"
        >
          {{ $t("common.close") }}
        </button>
      </template>
    </HistoryModal>
  </section>
</template>

<script>
import HistoryModal from "@/components/modal/HistoryModal";
import { productList } from "@/api/product";
import { preDownload } from "@/api/document";
import $ from "jquery";

export default {
  components: {
    HistoryModal,
  },
  data() {
    return {
      productList: [],
      doctypeList: [],
      docList: [],
      ecList: [],
      langList: [],
      historyList: [],
      pagingVO: "",
      form: {
        docId: "",
        paramProductList: [],
        paramDoctypeList: [],
        paramExhaustCertiList: [],
        paramLangList: [],
        publishedYn: "",
        page: 1,
      },
      filterShow: {
        product: true,
        product2: true,
        doctype: true,
        exhaust: true,
        lang: true,
      },
      showModal: false,
      docTitle: "",
      date: new Date().toISOString(),
    };
  },
  watch: {
    $route(to) {
      if (to.query.id != "") {
        this.form.paramProductList = [];
        this.form.paramProductList.push(to.query.id);
        this.onChangeChild(to.query.id);
        this.fetchData();
      }
    },
  },
  async created() {
    //  this.$root.$emit("setMenuClassActive", "Product");

    if (this.$route.query.id != null) {
      await this.initFacet();
      this.form.paramProductList.push(this.$route.query.id);
      this.onChangeChild(this.$route.query.id);
    }

    this.fetchData();
  },
  methods: {
    async initFacet() {
      try {
        const response = await productList(this.form);
        this.docList = response.data.docList;
        this.productList = response.data.productList;
      } catch (error) {
        console.log(error);
      }
    },
    async fetchData() {
      let loader = this.$loading.show({});
      try {
        this.form.docId = "";
        const response = await productList(this.form);
        this.pagingVO = response.data.pagingVO;
        this.docList = response.data.pagingVO.dataList;

        this.productList = response.data.productList;
        this.doctypeList = response.data.doctypeList;
        this.ecList = response.data.ecList;
        this.langList = response.data.langList;
        this.form.paramProductList = response.data.paramProductList;
        this.form.paramDoctypeList = response.data.paramDoctypeList;
        this.form.paramExhaustCertiList = response.data.paramExhaustCertiList;
        this.form.paramLangList = response.data.paramLangList;
        this.form.publishedYn = response.data.publishedYn;
        loader.hide();
      } catch (error) {
        console.log(error);
      }
    },
    searchPage(page) {
      // 페이지 클릭 시
      this.form.page = page;
      this.$store.commit("setPage", page);
      this.fetchData(this.form.page);
    },
    showHistoryPopup(docId, docTitle) {
      this.form.docId = docId;
      this.docTitle = docTitle;
      this.showModal = true;
    },
    closeModal() {
      this.showModal = false;
      this.form.docId = "";
      this.docTitle = "";
    },
    changeFilter() {
      //      this.fetchData();
      this.searchPage(1);
    },
    onChangeChild(prodId) {
      var checked = this.form.paramProductList.indexOf(prodId) > -1 ? true : false;
      for (var i = 0; i < this.productList.length; i++) {
        var currentProdId = this.productList[i].prodId;
        var children = this.productList[i].children;
        if (currentProdId == prodId && children != null) {
          for (var j = 0; j < children.length; j++) {
            if (checked) {
              this.form.paramProductList.push(children[j].prodId);
            } else {
              const idx = this.form.paramProductList.indexOf(children[j].prodId);
              if (idx > -1) this.form.paramProductList.splice(idx, 1);
            }
          }
        } else if (children != null) {
          var parentChecked =
            this.form.paramProductList.indexOf(currentProdId) > -1 ? true : false;
          var childChecked = false;
          for (j = 0; j < children.length; j++) {
            const idx = this.form.paramProductList.indexOf(children[j].prodId);
            if (idx > -1) childChecked = true;
          }
          if (!parentChecked && childChecked) {
            this.form.paramProductList.push(currentProdId);
          } else if (parentChecked && !childChecked) {
            const idx = this.form.paramProductList.indexOf(currentProdId);
            if (idx > -1) this.form.paramProductList.splice(idx, 1);
          }
        }
      }
    },
    filterInit() {
      this.form.paramProductList = [];
      this.form.paramExhaustCertiList = [];
      this.form.publishedYn = "";
      this.changeFilter();
    },
    publishedYnChange(publishedYn) {
      this.form.publishedYn = publishedYn;
      this.changeFilter();
    },
    changeShowFilter() {
      $(".fillter_inner").toggle();
    },
    changeShowProductFilter() {
      this.filterShow.product = !this.filterShow.product;
    },
    changeShowProduct2Filter() {
      this.filterShow.product2 = !this.filterShow.product2;
    },
    changeShowDoctypeFilter() {
      this.filterShow.doctype = !this.filterShow.doctype;
    },
    changeShowExhaustFilter() {
      this.filterShow.exhaust = !this.filterShow.exhaust;
    },
    changeShowLangFilter() {
      this.filterShow.lang = !this.filterShow.lang;
    },
    async pdfDownload(uid) {
      let loader = this.$loading.show({});

      const response = await preDownload(uid);
      if (response.data.status) {
        loader.hide();
        window.open("/document/download/pdf?uid=" + uid);
      } else {
        loader.hide();
        alert("Download failed");
      }
    },
  },
};
</script>

<style></style>
